import ArrowCircleClockwiseIcon from '@motional/inguitiv/svg/icon/arrow-circle-counter-clockwise.svg?react';

function Icon() {
  return <ArrowCircleClockwiseIcon />;
}

export default Icon;
